import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UploadPopupComponent } from './pages/upload-popup/upload-popup.component';

@Component({
  selector: 'app-setting-screen',
  templateUrl: './setting-screen.component.html',
  styleUrls: ['./setting-screen.component.scss'],
})
export class SettingScreenComponent {

  operationKeys = [
    'maneuvering',
    'idleInPort',
    'idleAtAnchorage',
    'loading',
    'discharging',
    'inerting',
    'gasFreeing',
    'tankCleaning',
    'maintainingTemp',
    'raisingTemp',
  ];
  settingForm: FormGroup;
  maxFoLadenRows = 5;
  maxFoBallastRows = 5;
  constructor(private fb: FormBuilder,  private dialog: MatDialog,) {
    this.settingForm = this.fb.group({
      foLaden: this.fb.array([this.createFoLadenGroup()]),
      foBallast: this.fb.array([this.createFoBallastGroup()]),
      maneuvering:this.fb.array([this.createManeuveringGroup()]),
      idleInPort: [0],
      idleAtAnchorage: [0],
      loading: [0],
      discharging: [0],
      inerting: [0],
      gasFreeing: [0],
      tankCleaning: [0],
      maintainingTemp: [0],
      raisingTemp: [0],
    });
  }
  createFoLadenGroup(): FormGroup {
    return this.fb.group({
      speed: [''],
      meConsumption: [''],
      auxEngine: [''],
      auxBoiler: [''],
      mgo: [''],
    });
  }
  createFoBallastGroup(): FormGroup {
    return this.fb.group({
      speed: [''],
      meConsumption: [''],
      auxEngine: [''],
      auxBoiler: [''],
        mgo: [''],
    });
  }
  createManeuveringGroup():FormGroup{
    return this.fb.group({
      meConsumption: [''],
      auxEngine: [''],
      auxBoiler: [''],
    });
  }
  get maneuvering(): FormArray {
    return this.settingForm.get('maneuvering') as FormArray;
  }
  get foLaden(): FormArray {
    return this.settingForm.get('foLaden') as FormArray;
  }

  get foBallast(): FormArray {
    return this.settingForm.get('foBallast') as FormArray;
  }

  addFoLadenRow() {
    if (this.foLaden.length < this.maxFoLadenRows) {
      this.foLaden.push(this.createFoLadenGroup());
    }
  }

  removeFoLadenRow(index: number) {
    if (this.foLaden.length > 1) {
      this.foLaden.removeAt(index);
    }
  }
  addFoBallastRow() {
    if (this.foBallast.length < this.maxFoBallastRows) {
      this.foBallast.push(this.createFoBallastGroup());
    }
  }

  removeFoBallastRow(index: number) {
    if (this.foBallast.length > 1) {
      this.foBallast.removeAt(index);
    }
  }

  formatLabel(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase());
  }

  submit() {
    console.log(this.settingForm.value);
  }
  uploadfile() {
   const dialog = this.dialog.open(UploadPopupComponent, {
      width: '600px',
      height: '400px',
      disableClose: true,
    });
}
}
